import api from '../..'
import { ICourseModel } from 'models/course.model'

export interface Course {
  data: Data
}

export interface Data {
  id: string
  type: string
  attributes: ICourseModel
}

const getCourse = (courseId: number) => {
  return api
    .get<Course>(`administration/courses/${courseId}`)
    .then(({ data }) => {
      return data.data.attributes
    })
}

export default getCourse
